/** @file stepClock: scrub a clip clock by whole frames (no events fire while scrubbing). */
import type { ClipClock } from '@zilo/pose3d-runtime-babylon/clip/clipClockTypes';

/** `time = max(0, time + frames / clip.fps)`, `prevTime = null`. */
export function stepClock(clock: ClipClock, frames: number): ClipClock {
  return { ...clock, time: Math.max(0, clock.time + frames / clock.clip.fps), prevTime: null };
}
